import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* createPerkWatcherSaga() {
  yield takeEvery(types.CREATE_PERKS_CALL_REQUEST, workerSaga);
}

export function createData(entitySlug, data) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/entity/${entitySlug}/perks/create/`;

  return axios.post(url, data)
    .then(val => val)
    .catch(err => err.response);
}

export function* workerSaga(action) {
  try {
    const { entitySlug, data, postRequest } = action;
    const response = yield call(createData, entitySlug, data);

    if (response && response.status >= 200 && response.status < 202) {
      yield put({ type: types.CREATE_PERKS_CALL_SUCCESS });
      yield put({ type: types.GET_PERKS_CALL_REQUEST, entitySlug });
      postRequest();
    } else {
      yield put({ type: types.CREATE_PERKS_CALL_FAILURE, error: response && response.data });
    }
  } catch (error) {
    yield put({ type: types.CREATE_PERKS_CALL_FAILURE, 'error': error && error.data});
  }
}
